import React, { useEffect, useRef } from 'react';

interface ToggleProps {
    className?: string;
    checked: boolean;
    ariaLabel?: string;
    label: string;
    id?: string;
    onChange: () => void;
}

const SimpleToggle: React.FC<ToggleProps> = ({
    className,
    checked,
    label,
    id,
    onChange,
}) => {
    return (
        <label className={`o-toggle-switch ${className || ''}`} id={id}>
            <input type="checkbox" checked={checked} onChange={onChange} />
            {label}
        </label>
    );
};

export default SimpleToggle;
